import { Injectable } from '@angular/core';
import {cloneDeep, forEach, get, includes, reduce, set} from "lodash-es";
import {WmHttpService} from "@wms/services";
import {VARIABLE_CONSTANTS} from "@wms/variables";
import {BaseComponent} from "@wms/components";
import {environment} from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class ProfileApiService extends BaseComponent{

  private TARGET: string = 'DeploymentProfiles';
  private API_META: any = {
    list: {
      url: environment.SERVICES_BASE_PATH + 'services/projects/:projectID/profiles/profile-names',
      method: 'GET'
    },
    createProfile: {
      url: environment.SERVICES_BASE_PATH + 'services/projects/:projectID/profiles',
      method: 'POST'
    },
    getProfile: {
      url: environment.SERVICES_BASE_PATH + 'services/projects/:projectID/profiles/:profileName',
      method: 'GET'
    },
    updateProfile: {
      url: environment.SERVICES_BASE_PATH + 'services/projects/:projectID/profiles/:profileName',
      method: 'PUT'
    },
    deleteProfile: {
      url: environment.SERVICES_BASE_PATH + 'services/projects/:projectID/profiles/:profileName',
      method: 'DELETE'
    },
    appEnvironmentProfile: {
      url: environment.SERVICES_BASE_PATH + 'services/projects/:projectID/properties',
      method: 'PUT'
    },
    appEnvironmentProperties: {
      url: environment.SERVICES_BASE_PATH + 'services/projects/:projectID/properties/keys',
      method: 'GET'
    },
    getContainerServicesDeployedUrl: {
      url: '/deployment-cloud/rest/projects/:projectID/deployment-url',
      method: 'GET'
    }
  }
  PROFILE_TYPE = {
    PREFAB: 'prefab',
    APP: 'app'
  }
  _profileMap: any = {}

  constructor(private wmHttpService: WmHttpService) {
    super();
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }

  getInfoMap(props: any, target?: any){
    let retObj = {},
      profileProps = props;

    if (target) {
      profileProps = reduce(props,(result: any, prop: any) => {
        var propName = prop.name,
          parts = propName.split('.');
        if(parts[0] === this.PROFILE_TYPE.PREFAB && parts[1] === target) {
          result.push(prop);
        }
        return result;
      }, []);
    }
    forEach(profileProps, (prop) => {
      var propName = prop.name,
        parts = propName.split('.');
      if (target) {
        parts = parts.splice(2);
      }
      this.setProperties(retObj, parts, prop);
    });
    return retObj;
  }

  getProfile(profileName: any, isSave?: any): Promise<any> {
    if (this._profileMap[profileName] && !isSave){
      return Promise.resolve(cloneDeep(this._profileMap[profileName]));
    }
    return (this.wmHttpService.execute({
      target: "DeploymentProfiles",
      action: "getProfile",
      pathParams: {
        projectID: this.projectService.getProjectId(),
        profileName: profileName
      }
    }) as Promise<any>).then((res) => {
        this._profileMap[profileName] = cloneDeep(res);
        return res;
      });
  }

  list() {
    return (this.wmHttpService.execute({
      target: "DeploymentProfiles",
      action: "list",
      pathParams: {
        projectID: this.projectService.getProjectId()
      }
    }) as Promise<any>);
  }

  getContainerServicesDeployedUrl(projectId: any) {
    return this.wmHttpService.execute({
      target: "DeploymentProfiles",
      action: "getContainerServicesDeployedUrl",
      pathParams: {
        projectID: projectId
      }
    }
    )
  }

  /**
   * sets the profile property value.
   */
  setProperties(retObj: any, parts:any, prop: any) {
    // parts[0] will determine the type of the property. ie, db, security, rest etc
    // parts[1] will contain the DB Name.
    // parts[2] will contain the propertyName
    if (!retObj.hasOwnProperty(parts[0])) {
      retObj[parts[0]] = {};
    }
    if (!retObj[parts[0]].hasOwnProperty(parts[1])) {
      if (parts[0] === 'db') {
        retObj[parts[0]][parts[1]] = {
          url: undefined,
          username      : undefined,
          password      : undefined,
          maxPageSize   : undefined,
          maxPoolSize   : undefined,
          minPoolSize   : undefined,
          dataSourceType: undefined,
          jndiName      : undefined
        };
      } else if (parts[0] === 'rest') {
        retObj[parts[0]][parts[1]] = {
          host: undefined,
          basepath: undefined,
          scheme: undefined,
          apiKeys: []
        };
      } else if (parts[0] === 'websocket') {
        retObj[parts[0]][parts[1]] = {
          host: undefined,
          basepath: undefined,
          scheme: undefined
        };
      } else if (parts[0] === 'soap') {
        retObj[parts[0]][parts[1]] = {
          connectionTimeout: undefined,
          requestTimeout: undefined,
          endpoint: undefined,
          username: undefined,
          password: undefined
        };
      } else if (parts[0] === 'security') {
        if (parts[1] === 'general') {
          retObj[parts[0]][parts[1]] = {
            'ssl.enabled': undefined,
            'ssl.port': undefined,
            'rememberMe.enabled': undefined,
            'rememberMe.timeOut': undefined,
            'session.timeout': undefined,
            'xsrf.enabled': undefined,
            'xss.enabled': undefined,
            'cookie.maxAge': undefined
          };
        } else if (parts[1] === 'activeProviders') {
          retObj[parts[0]] = {};
          retObj[parts[0]][parts[1]] = prop.value;
        } else if (parts[1] === 'enabled') {
          retObj[parts[0]][parts[1]] = prop.value;
        } else if (parts[1] === 'session') {
          retObj[parts[0]][parts[1]] = {
            'persistence.type': undefined,
            'jdbc.serviceName': undefined,
            'redis.database': undefined,
            'redis.host': undefined,
            'redis.port': undefined,
            'redis.password': undefined,
            'mongodb.host': undefined,
            'mongodb.port': undefined,
            'mongodb.username': undefined,
            'mongodb.password': undefined,
            'mongodb.dbname': undefined,
          };
        }
      } else if (parts[0] === 'app' && parts[1] === 'environment') {
        retObj[parts[0]] = {};
        retObj[parts[0]][parts[1]] = {};
      } else if (parts[0] === VARIABLE_CONSTANTS.REST_SERVICE.SECURITY_DEFN_OAUTH2) {
        retObj[parts[0]][parts[1]] = {};
      } else if (parts[0] === 'prefab') {
        retObj[parts[0]] = {};
        retObj[parts[0]][parts[1]] = {};
      } else if (parts[0] === 'build' && parts[1] === 'ui') {
        if ((parts[2] && parts[2] === 'mode') || (parts[2] && parts[3] && parts[2] === 'angular' && parts[3] === 'args')) {
          set(retObj, parts, prop);
        }
      } else {
        return;
      }
    }
    if (parts[0] === 'security' && parts[1] !== 'enabled' && !get(retObj, [parts[0], parts[1], parts[2]])) {
      if (parts[1] === 'providers' && parts[2]) {
        if (parts[2] === 'ad') {
          set(retObj, [parts[0], parts[1], parts[2]], {
            'domain': undefined,
            'rootDn': undefined,
            'url': undefined
          });
        } else if (parts[2] === 'ldap') {
          set(retObj, [parts[0], parts[1], parts[2]], {
            'url': undefined,
            'userSearchPattern': undefined
          });
        } else if (parts[2] === 'cas') {
          set(retObj, [parts[0], parts[1], parts[2]], {
            'artifactParameter': undefined,
            'loginUrl': undefined,
            'logoutUrl': undefined,
            'serverUrl': undefined,
            'serviceParameter': undefined,
            'validationUrl': undefined
          });
        } else if (parts[2] === 'saml') {
          set(retObj, [parts[0], parts[1], parts[2]], {
            'idpMetadataUrl' : undefined,
            'keyAlias' : undefined,
            'keyStoreFile' : undefined,
            'keyStorePassword' : undefined,
            'urlValidateType' : undefined
          });
        } else if (parts[2] === 'openId') {
          set(retObj, [parts[0], parts[1], parts[2], parts[3]], {});
        } else if (parts[2] === 'jws') {
          set(retObj, [parts[0], parts[1], parts[2], parts[3]], {});
        }else if(parts[2] === 'opaqueToken'){
          set(retObj, [parts[0], parts[1], parts[2]], {})
        }else {
          retObj[parts[0]][parts[1]] = prop.value;
        }
      }
    }
    if(parts[0] === "security" && parts[1] === "session") {
      retObj[parts[0]][parts[1]][parts[2] + '.' + parts[3]] = prop;
      if((parts[2] === "persistence" && parts[3] === "type")
        || (parts[2] === "jdbc" && parts[3] === "serviceName")
        || (parts[2] === "redis" && ['database', 'port', 'host', 'password'].includes(parts[3]))
        || (parts[2] === "mongodb" && ['host', 'port', 'username', 'password', 'dbname'].includes(parts[3]))) {
        retObj[parts[0]][parts[1]][parts[2] + '.' + parts[3]].value = prop.value;
      }
    }

    if (parts[0] === 'security' && parts[1] === 'general') {
      retObj[parts[0]][parts[1]][parts[2] + '.' + parts[3]] = prop;
      if (parts[2] === "session" && parts[3] === "timeout") {
        retObj[parts[0]][parts[1]][parts[2] + '.' + parts[3]].value = +prop.value;
      } else if (parts[2] === "rememberMe" && parts[3] === "timeOut") {
        retObj[parts[0]][parts[1]][parts[2] + '.' + parts[3]].value = (+prop.value);
      } else if (parts[2] === "cors" && parts[3] === "maxAge") {
        retObj[parts[0]][parts[1]][parts[2] + '.' + parts[3]].value = (+prop.value);
      } else if (parts[2] === "cookie" && parts[3] === "maxAge") {
        retObj[parts[0]][parts[1]][parts[2] + '.' + parts[3]].value = (+prop.value);
      }else if (parts[2] === "cors" && parts[3] === "pathEntries") {
        retObj[parts[0]][parts[1]][parts[2] + '.' + parts[3]+ '.' + parts[4]] = prop;
      }else if (parts[2] === "mtls" && ["fileType", "file", "password"].includes(parts[4])) {
        retObj[parts[0]][parts[1]][parts[2] + '.' + parts[3]+ '.' + parts[4]] = prop;
      }
    } else if (parts[0] === 'security' && parts[1] === 'providers' && parts[2]) {
      set(retObj, parts, prop);
    } else if (parts[0] === 'app' && parts[1] === 'environment') {
      retObj[parts[0]][parts[1]][parts.slice(2).join('.')] = prop;
    } else if (!includes(["security", "soap", "environment","build"], parts[0])) {
      retObj[parts[0]][parts[1]][parts[2]] = prop;
    } else if (parts[0] === 'soap') {
      if (parts[2] === "connectionTimeout" || parts[2] === "requestTimeout") {
        prop.value = +prop.value;
      }
      retObj[parts[0]][parts[1]][parts[2]] = prop;
    } else if (parts[0] === 'build' && parts[1] === 'ui') {
      set(retObj, parts, prop)
    }

    if(parts[0] === 'rest' && parts[2] === 'apikey') {
      prop.displayKey = parts[4];
      retObj[parts[0]][parts[1]].apiKeys.push(prop);
    }

    return retObj;
  }

  updateProfile(profileName: any, profileInfo: any) {
    return this.wmHttpService.execute({
      target: "DeploymentProfiles",
      action: "updateProfile",
      toasterInfo: {
        'error': { title: this.locale.MESSAGE_ERROR_TITLE, description: this.locale.MESSAGE_ERROR_DEPLOYMENT_PROFILE_UPDATE },
        'success': { title: this.locale.MESSAGE_SUCCESS_TITLE, description: this.locale.MESSAGE_SUCCESS_DEPLOYMENT_PROFILE_UPDATE }
      },
      pathParams: {
        projectID: this.projectService.getProjectId(),
        profileName: profileName
      },
      data: profileInfo
    })
  }

  createProfile(profileName: any) {
    return this.wmHttpService.execute({
      target: "DeploymentProfiles",
      action: "createProfile",
      pathParams: {
        projectID: this.projectService.getProjectId()
      },
      data: profileName
    })
  }

  deleteProfile(profileName: any) {
    return this.wmHttpService.execute({
      target: "DeploymentProfiles",
      action: "deleteProfile",
      pathParams: {
        projectID: this.projectService.getProjectId(),
        profileName: profileName
      }
    })
  }
  appEnvironmentProfile(profileInfo: any){
    return (this.wmHttpService.execute({
      target: "DeploymentProfiles",
      action: "appEnvironmentProfile",
      toasterInfo: { 'error': { title: this.locale.MESSAGE_ERROR_TITLE, description: this.locale.MESSAGE_ERROR_DEPLOYMENT_PROFILE_UPDATE },
        'success': { title: this.locale.MESSAGE_SUCCESS_TITLE, description: this.locale.MESSAGE_SUCCESS_DEPLOYMENT_PROFILE_UPDATE },
      },
      pathParams: {
        projectID: this.projectService.getProjectId()
      },
      data: profileInfo
    }) as Promise<any>).then(()=>{
      this._profileMap = {};
    })
  }

  appEnvironmentProperties() {
    return this.wmHttpService.execute({
      target: "DeploymentProfiles",
      action: "appEnvironmentProperties",
      pathParams: {
        projectID: this.projectService.getProjectId()
      },
    })
  }
}
